import React, { Fragment } from 'react';
import { Field } from 'react-final-form-html5-validation';

function SignatureDate(props) {

  const todaysDate = new Date().toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });

  return (
	  <Fragment>
		<div className="container-fluid p-0" style={{position: 'relative', top: '-21px'}}>
			<div className="col-sm-8 pl-0 pr-0 text-left" style={{float: 'left', width: '77%', clear: 'both'}}>
				<p className="sig-help-font desktop">Use your mouse to sign your name in the field above.</p>
				<p className="sig-help-font mobile">Use your finger to sign your name in the field above.</p>
			</div>
			<div style={{display: 'inline-block', verticalAlign: 'top'}} className="col-sm-4 text-right pr-1">
				<p className="sig-help-font">Dated: {todaysDate}</p>
			</div>
		</div>
		<Field 
			name={props.forDate + "Date"}
			component="input"
			defaultValue={todaysDate}
		>
			{({ input, meta }) => (
				<Fragment>
					<input {...input} value={todaysDate} type="text" className="form-control full-width-input hidden-field" tabIndex="-1" />
				</Fragment>
			)}
		</Field>
	</Fragment>
  	)
  }	

  export default SignatureDate;